import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";
import { faInbox } from "@fortawesome/pro-light-svg-icons";
import { useTranslation } from "react-i18next";

const Loading: React.FC<{ loading: boolean; fullSize?: boolean }> = ({
  loading,
  fullSize,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`m-auto text-center font-medium text-2xl text-default-text ${
        fullSize ? "mt-[20%] mb-[20%]" : "mt-20"
      }`}
    >
      {loading ? (
        <FontAwesomeIcon
          className="animate-spin w-16 h-16"
          icon={faSpinnerThird}
        />
      ) : (
        <p>
          <FontAwesomeIcon className="mr-4" icon={faInbox} />
          {t("Message.No results found")}
        </p>
      )}
    </div>
  );
};

export default Loading;
